export default __webpack_public_path__ + "static/media/increase.7c8c9534.svg";